var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTreeFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 7C19.5523 7 20 7.44772 20 8L20 17C20 17.5523 19.5523 18 19 18L5 18C4.44772 18 4 17.5523 4 17L4 6C4 5.44771 4.44772 5 5 5L8.58579 5C8.851 5 9.10536 5.10536 9.29289 5.29289L10.7071 6.70711C10.8946 6.89464 11.149 7 11.4142 7L19 7Z",
    stroke: "#CCCFD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTreeFolder);
export default __webpack_public_path__ + "static/media/icon-tree-folder.287b6e2f0ef2d98412d4c1ae7f2150de.svg";
export { ForwardRef as ReactComponent };